import { Component, EventEmitter, Input, OnChanges, OnInit, Output } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { DoctorAppointment, EAppointmentState } from 'src/app/entities/appointment.entity';
import { ConsultationMotif } from 'src/app/entities/consultation.entity/consultation-motif.entity/consultation-motif';
import { EDalyTimeSlotLocation } from 'src/app/entities/daly-time-slot.entity/daly-time-slot';
import { DoctorAvailability } from 'src/app/entities/doctor-disponiblity.entity/doctor-availability';
import { DoctorPatient } from 'src/app/entities/doctor-patient.entity/doctor-patient';
import { Doctor } from 'src/app/entities/user.entity/doctor.entity';
import { DoctorSecretary } from 'src/app/entities/user.entity/doctor.entity/secretary.entity';
import { AuthService } from 'src/app/services/auth.service/auth.service';
import { DoctorSecretariesService } from 'src/app/services/doctor-secretaries.service/doctor-secretaries.service';
import { DoctorSecretaryAppointmentsService } from 'src/app/services/doctor-secretary-appointments.service/doctor-secretary-appointments.service';

@Component({
  selector: 'app-update-rendez-vous-secretary',
  templateUrl: './update-patient-secretary.component.html',
  styleUrls: ['./update-patient-secretary.component.css'],
})
export class UpdatePatientSecretaryComponent implements OnInit, OnChanges {

  @Input() doctorPatients: DoctorPatient[] = [];
  @Input() userTarget!: DoctorPatient;
  @Input() location: EDalyTimeSlotLocation = EDalyTimeSlotLocation.ATSITE;
  @Input() disponibilites: DoctorAvailability[] = [];
  @Input() disponibiliteDefalut: number = 0;
  @Input() disponibilite: DoctorAvailability = new DoctorAvailability({});
  @Input() doctorAppointment: DoctorAppointment = new DoctorAppointment({
    status: EAppointmentState.PENDING,
    motif: "Consultation Régulière",
  });

  @Input() consultationMotifs: ConsultationMotif[] = [];
  @Input() date: string = "";
  @Input() dateDisponibilte!: Date;
  @Input() assistanceId: string = "";
  @Input() filter: boolean = false;

  @Output() refreshData: EventEmitter<void> = new EventEmitter();
  @Output() close: EventEmitter<void> = new EventEmitter();

  heureInput: string = "";
  changeValueDisponibilte: boolean = false;

  usersList: any[] = [];
  selectedUser: any;

  // ✅ couleur principale
  selectedColor: string = '';

  constructor(
    private doctorSecretaryAppointmentsService: DoctorSecretaryAppointmentsService,
    private authservice: AuthService,
    private toastrService: ToastrService,
    private doctorSecretariesService: DoctorSecretariesService
  ) {}

  get doctor(): Doctor {
    return this.authservice.getCurrentUser() as Doctor;
  }

  get secrectary(): DoctorSecretary {
    return this.authservice.getCurrentUser() as DoctorSecretary;
  }

  ngOnInit(): void {
    this.changeValueDisponibilte = this.filter;
    this.heureInput = this.msToTime(this.disponibilite.startTime);
this.location = this.doctorAppointment.location;
    this.getAssistants();

    this.disponibiliteDefalut = this.disponibilite.startTime;
  }
trackById(index: number, item: any) {
  return item.id;
}
  ngOnChanges() {
    this.heureInput = this.msToTime(this.disponibilite.startTime);
this.location = this.doctorAppointment.location;
    if (this.usersList.length && this.doctorAppointment?.assistantId) {
      this.selectedUser = this.usersList.find(
        u => u.id === this.doctorAppointment.assistantId
      );

      // ✅ init couleur depuis backend
      this.selectedColor = this.doctorAppointment.assistanceColorCode || this.doctorAppointment.colorCode;
    }
  }

  getAssistants() {
    this.doctorSecretariesService.getAssistantList().subscribe({
      next: (res: any) => {

        const medecin = { ...res.medecin, type: 'DOCTOR' };

        const assistants = res.assistants.map((a: any) => ({
          ...a,
          type: 'ASSISTANT'
        }));

        this.usersList = [medecin, ...assistants];

        // ✅ init selected user
        this.selectedUser = this.usersList.find(
          u => u.id === this.doctorAppointment.assistantId
        ) || null;
this.location=this.doctorAppointment.location;
        // ✅ init couleur
        this.selectedColor = this.doctorAppointment.assistanceColorCode || this.doctorAppointment.colorCode || '#FADADD';
      }
    });
  }

  // ✅ comparer objets select
  compareUsers(u1: any, u2: any): boolean {
    return u1 && u2 ? u1.id === u2.id : u1 === u2;
  }

  // ✅ changement user → update couleur
  onUserChange() {
    if (this.selectedUser) {
      this.selectedColor = this.selectedUser.colorCodeAct || '#FADADD';
      this.doctorAppointment.colorCode = this.selectedColor;
      
    }
  }

  // 🎨 couleurs disponibles
  colors = [
    { value: "#FADADD" },
    { value: "#B8E994" },
    { value: "#FFF9B0" },
    { value: "#A8D8EA" },
    { value: "#FFDAB9" },
    { value: "#E6E6FA" },
    { value: "#DFFFBF" },
    { value: "#F5F5DC" },
    { value: "#BFD7ED" },
    { value: "#FFB6B9" }
  ];

  isOpen = false;

  toggleDropdown() {
    this.isOpen = !this.isOpen;
  }

  // ✅ changement manuel couleur
  selectColor(color: string) {
    this.selectedColor = color;
    this.isOpen = false;
  }

  onTimeChange(event: any) {
    const value = event.target.value;

    if (!value) {
      this.disponibilite.startTime = 0;
      return;
    }

    const [hours, minutes] = value.split(":").map(Number);

    const milliseconds =
      (hours * 60 * 60 * 1000) +
      (minutes * 60 * 1000);


    this.disponibilite.startTime = milliseconds;
    this.disponibiliteDefalut =milliseconds
  }


  msToTime(ms: number): string {
    const totalSeconds = Math.floor(ms / 1000);
    const hours = Math.floor(totalSeconds / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);

    return `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}`;
  }

  change(event: any) {
    this.changeValueDisponibilte = event.isTrusted;
  }

  refresh(event: DoctorPatient) {
    this.userTarget = event;
    this.refreshData.emit();
  }

  sumbit() {

    const [day, month, year] = this.date.split("/").map(Number);

    this.doctorAppointment.date = new Date(year, month - 1, day);
this.doctorAppointment.colorCode = this.selectedColor;
    // ✅ sync assistant
    if (this.selectedUser) {
      this.doctorAppointment.assistantId = this.selectedUser.id;
      this.doctorAppointment.assistanceColorCode = this.selectedColor;
    }

    this.doctorAppointment.startTime =
      this.disponibilite?.startTime || this.doctorAppointment.startTime;

    this.doctorAppointment.duration = this.doctorAppointment.duration || 30;
this.doctorAppointment.location = this.location;
    if (this.userTarget) {
      this.doctorSecretaryAppointmentsService
        .update(this.doctorAppointment.id, this.doctorAppointment)
        .subscribe({
          next: () => {
            this.toastrService.success("Rdv mis à jour avec succès");

            this.refreshData.emit();
            this.close.emit();
          },
          error: (err) => {
            this.toastrService.error(err?.error?.message || "Erreur");
            this.close.emit();
          }
        });
    } else {
      this.toastrService.warning("Veuillez sélectionner un patient");
      this.close.emit();
    }
  }
}